import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from "pinia";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import ElementPlus from 'element-plus'
import zhCn from "element-plus/es/locale/lang/zh-cn";
// 替换旧插件
import Particles from '@tsparticles/vue3'
import { loadSlim } from '@tsparticles/slim'
// VueParticles 已移除

import 'element-plus/dist/index.css'
import './assets/base.css'

// vue-quill-editor 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const pinia = createPinia();
const app = createApp(App)
    .use(router)
    .use(pinia)
    .use(ElementPlus, { locale: zhCn })
    .use(Particles, {
        init: async (engine) => {
            await loadSlim(engine)
        }
    })
    .use(VueQuillEditor);

app.mount('#app');

// 引入Icon 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}